// cookie-utils.ts

export interface CookieOptions {
  path?: string;
  domain?: string;
  expires?: Date | number; // number = days from now
  secure?: boolean;
  sameSite?: 'Lax' | 'Strict' | 'None';
  httpOnly?: boolean; // Note: HttpOnly cookies cannot be set via JavaScript; this is just for completeness.
}

export function setCookie(name: string, value: string, options: CookieOptions = {}) {
  let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.expires) {
    const expires = typeof options.expires === 'number' ? new Date(Date.now() + options.expires * 864e5) : options.expires;
    cookieStr += `; expires=${expires.toUTCString()}`;
  }

  cookieStr += `; path=${options.path || '/'}`;

  if (options.domain) cookieStr += `; domain=${options.domain}`;
  if (options.secure) cookieStr += `; secure`;
  if (options.sameSite) cookieStr += `; samesite=${options.sameSite}`;

  document.cookie = cookieStr;
}

export function getCookie(name: string): string | null {
  const encoded = encodeURIComponent(name) + '=';
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(encoded)) {
      return decodeURIComponent(trimmed.substring(encoded.length));
    }
  }

  return null;
}

export function deleteCookie(name: string, path: string = '/', domain?: string) {
  setCookie(name, '', {
    path,
    domain,
    expires: new Date(0)
  });
}

export function checkCookie(name: string): boolean {
  return getCookie(name) !== null;
}
